import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Websites from '../../stores/websites'

@inject('auth')
@observer
class Zapier extends Component {
  state = {
    websites: new Websites(),
    error: false
  }

  componentWillMount() {
    this.state.websites.load()
  }

  handleSubmit = event => {
    event.preventDefault()
    const { website } = this.form

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const url = urlParams.get('redirect_uri') || process.env.ZAPIER_REDIRECT_URL
    const state = urlParams.get('state')

    window.location = `${url}?code=${website.value}|${this.props.auth.user.id}&state=${state}`
  }

  render() {
    const { websites } = this.state

    const errorMessage = this.state.error && <div className="error">Error connecting to Zapier.</div>

    return (
      <div className="container provision">
        <div className="dialog provision">
          <form onSubmit={this.handleSubmit} ref={f => this.form = f}>
            <h2>Connect to Zapier</h2>
            <p>Choose a website below to connect to Zapier:</p>

            {errorMessage}
            {websites.loaded && 
              <div className="websites">
                {Object.values(websites.websites).map(website => (
                  <label key={website.id}>
                    <input type="radio" name="website" value={website.uuid} />
                    {website.name}
                  </label>
                ))}
              </div>}

            <button type="submit" disabled={!websites.loaded}>
              Connect Website
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default Zapier



// WEBPACK FOOTER //
// client/components/auth/Zapier.js